export default "__VITE_ASSET__b539e07f__"